export enum Runtime {
  Nodejs = 'Nodejs',
  Netcore = 'Netcore',
  Jvm = 'Jvm',
  Python = 'Python',
  Ruby = 'Ruby',
  Php = 'Php',
}
